import React from 'react';
import NodeSymbolSelect from './NodeSymbolSelect';
import { Handle, Position } from 'reactflow';

export default function DivergenceNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #9333ea',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#c084fc' }}>
        🔀 Divergence
      </div>
      <NodeSymbolSelect value={data.symbol} onChange={(v) => onChange('symbol', v)} />

      <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
        <select
          value={data.direction || 'bearish'}
          onChange={(e) => onChange('direction', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="bearish">Bearish</option>
          <option value="bullish">Bullish</option>
        </select>
        <input
          type="number"
          min={2}
          value={data.lookback ?? 14}
          onChange={(e) => onChange('lookback', Math.max(2, parseInt(e.target.value, 10) || 14))}
          style={{ width: 64, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      <div style={{ fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Requires an indicator (e.g. RSI) wired into the left input. Compares price vs. that indicator's direction over the lookback window — a simplified N-bar comparison, not full swing-based divergence. Outputs 1 when detected, otherwise 0.
      </div>

      <Handle type="target" position={Position.Left} id="source" style={{ background: '#9333ea' }} />
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#9333ea' }} />
    </div>
  );
}
